import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <div class="container d-flex flex-column align-items-center">
      <app-nav></app-nav>
      <div style="padding-bottom: 50px">
        <app-about></app-about>
        <app-projects></app-projects>
        <!-- <app-stack></app-stack>
        <app-contact></app-contact> -->
      </div>
    </div>
  `,
  styles: [``],
})
export class AppComponent {
  title = 'portfolio';
}
